/* eslint-disable max-len */
const SendIcon = ({ className }: { className?: string }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 24 24" 
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M10 14L21 3" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M21 3L14.5 21C14.4104 21.1955 14.2151 21.3209 14 21.3209C13.7849 21.3209 13.5896 21.1955 13.5 21L10 14L3.00001 10.5C2.80449 10.4104 2.67914 10.2151 2.67914 10C2.67914 9.78493 2.80449 9.5896 3.00001 9.5L21 3" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendIcon;
